import React from "react";

const AddCircle = ({ style }) => (
  <svg
    width="23"
    height="23"
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.3413 21.0787C16.5016 21.0787 20.7237 16.8566 20.7237 11.6963C20.7237 6.53602 16.5016 2.31396 11.3413 2.31396C6.18104 2.31396 1.95898 6.53602 1.95898 11.6963C1.95898 16.8566 6.18104 21.0787 11.3413 21.0787Z"
      stroke="#F4F4F4"
      strokeWidth="1.97029"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.58887 11.6962H15.0947"
      stroke="#F4F4F4"
      strokeWidth="1.97029"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.3413 15.4492V7.94336"
      stroke="#F4F4F4"
      strokeWidth="1.97029"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default AddCircle;
